import slick from 'slick-carousel';
import imgLiquid from 'plugs/imgLiquid-min.js';
import 'plugs/jquery.easing.1.3.js';
import 'plugs/svg.js';
import 'plugs/jquery.simplyscroll.min.js';
import 'plugs/jquery.pause.min.js';
import 'plugs/jquery.twzipcode.js';


var $window = $(window);
var winW,winH,footerH,bodyH,scrollTop;


window.onload = function() { 
    
};
$('body').addClass('fade-in');
window.setTimeout(function(){       
    $('html,body').removeClass('modal-open');
},500);
window.setTimeout(function(){       
    $('.overlay').fadeOut(100);
},700);
$(function(){    
        
    // $("img").lazyload();
    
    $("#topBtn").click(function() {
        $("html,body").animate({ scrollTop: 0 }, 1000, 'easeOutExpo');
        return false;
    });
    //scroll animation
    var win_height_padded = $window.height() * 0.9;
    window.setTimeout(function(){
        $window.on('scroll', revealOnScroll);
        revealOnScroll();
    },900);
    //mobile menu
    var menuicon = $('header .menuicon'),
    navBox = $('header .mmenu'),
    nav = $('header .navBox'),
    $body = $('body,html'),
    $header = $('header');

    menuicon.on('click',function(){
        var $this = $(this);
        if(!$header.hasClass('menu-expanded')){
            $header.addClass('menu-expanded');
            nav.stop().fadeIn();
        }else{
            $header.removeClass('menu-expanded');
            nav.stop().fadeOut(function(){$(this).removeAttr('style');});
        }
        return false;
    });
    
    $('.navBox a').on('click',function(){
        var obj = $(this).attr('href');
        $("html,body").animate({ scrollTop: $(obj).offset().top}, 1000, 'easeOutExpo');
        $header.removeClass('menu-expanded');
        nav.stop().fadeOut(function(){$(this).removeAttr('style');});
        return false;
    });
    //open real    
    var btn_close = $('span.close,a.close'),
        btn_open = $('a[data-popup]'),
        //$body_overlay = $('.popup_bg'),
        $real_overlay = $('.overbg'),
        window_top,
        poval;
    btn_open.on('click',function(event){
        window_top = scrollTop;
        poval = $(this).data('popup');
        $('.modal-content').addClass(poval);
        $body.addClass('modal-open');
        $real_overlay.fadeIn('800');
        $('#modal-content').fadeIn('800');
        return false;
    });
    btn_close.on('click',function(){       
        $real_overlay.fadeOut(500);
        $('.modal-content').fadeOut(500,function(){
          $body.removeClass('modal-open');   
            $('.modal-content').removeClass(poval);
        });
        if(winW < 1024){
          $window.scrollTop(window_top);
        }else{
          $body.removeAttr('data-top');
        }        
    });
    $window.on('resize',function(){
        winW = $window.width();
        winH =  $window.height();
        footerH = $('footer').outerHeight(true);
        bodyH = winH - footerH;  
        //bodyH
        $('main').css('min-height',bodyH);
        if(winW > 991){
            $header.removeClass('menu-expanded');
            $('.navBox').removeAttr('style');
            nav.stop().fadeOut(function(){$(this).removeAttr('style');});
            $body.css({'overflow':''});
        }
    }).resize();
    $(window).on('scroll', function() {
        scrollTop = $(this).scrollTop();
        var top = $('#topBtn');
        if (scrollTop >= 47) {
            top.addClass('open');
        }else{
            top.removeClass('open');
        }
    }).scroll();
    $('.slicklg-3').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover:false,
        autoplay:true,
        autoplaySpeed:4000,
        speed:1500,
        dots:false,
        arrows: false,
        asNavFor: '.slick-3',
    });
    $('.slick-3').slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        pauseOnHover:false,
        infinite: true,
        dots:false,
        arrows: false,
        asNavFor: '.slicklg-3',
        responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
            },
            {
                breakpoint: 575,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                }
              },
        ]
    });
    $('.slick-3 .slick-slide').on('click',function(){
        var slideIndex = $(this).index();
        $('.slicklg-3').slick('slickGoTo', parseInt(slideIndex));
    });
    $('.btn-slick-prev').click(function(){
        $('.slick-3').slick("slickPrev");
    });
    $('.btn-slick-next').click(function(){
        $('.slick-3').slick("slickPrev");
    });
    $("#twzipcode").twzipcode({
        onCountySelect: function() {
            if($(this).val() == ""){
                $('#city_span').html("必填");
                $("#twzipcode").addClass('nonsel');
			}else {
                $('#city_span').html("");
                $("#twzipcode").removeClass('nonsel');
            }
        }
    });
    
});

function revealOnScroll() {
    var scrolled = $window.scrollTop(),
        win_height_padded = $window.height() * 0.9;

   
    $(".revealOnScroll:not(.animated)").each(function () {
    var $this     = $(this),
        offsetTop = $this.offset().top;

    if (scrolled + win_height_padded > offsetTop) {
        $this.addClass('animated');
    }
    });
}
